/**
 * Softeq Development Corporation
 * https://www.softeq.com
 */

export * from './material.module';
